import i18n from "i18next";
import type { FC } from "react";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import type { Entity } from "../../core/types/fe/Entity";
import { SecondaryButton } from "../Buttons/components/ActionButton";
import { ConfirmationModal } from "../Modal/ConfirmationModal";

export type DeleteButtonProps = {
    isDisabled: boolean;
    callback?: (itemToDelete?: Entity) => void;
    itemToDelete?: Entity;
    modalMessage?: string;
};

export const DeleteButton: FC<DeleteButtonProps> = ({ isDisabled, callback, itemToDelete, modalMessage }) => {
    const { t } = useTranslation();
    const [isModalVisible, setIsModalVisible] = useState(false);

    const requestUserConfirmation = useCallback(() => {
        setIsModalVisible(true);
    }, [setIsModalVisible]);

    const onOk = useCallback(() => {
        setIsModalVisible(false);
        if (callback) {
            callback(itemToDelete);
        }
    }, [callback, itemToDelete, setIsModalVisible]);

    const onCancel = useCallback(() => {
        setIsModalVisible(false);
    }, [setIsModalVisible]);

    return (
        <>
            <ConfirmationModal
                visible={isModalVisible}
                title={i18n.t("genericTable.deleteModal.title")}
                onOk={onOk}
                onCancel={onCancel}
                message={modalMessage || t("genericTable.deleteModal.message")}
            />
            <SecondaryButton name="delete" onClick={requestUserConfirmation} disabled={isDisabled}>
                {i18n.t("button.delete")}
            </SecondaryButton>
        </>
    );
};
